import {Component, inject} from '@angular/core'
import {InterestTable} from '../../1-components/20-settings/interest-table/interest-table'
import {Configuration} from '../../services/configuration'
import {FormsModule} from '@angular/forms'
import {ProductionPriceTable} from '../../1-components/20-settings/production-price-table/production-price-table'
import {BindingDiscount} from '../../1-components/20-settings/binding-discount/binding-discount'
import {Simulator} from './simulator/simulator'
import {SaveButton} from './save-button/save-button'
import {InterestInput} from '../../1-components/20-settings/interest-input/interest-input'
import {SavingsInterests} from '../../1-components/20-settings/savings-interests/savings-interests'
import {DerivedTable} from '../../1-components/20-settings/derived-table/derived-table'

@Component({
  selector: 'spb-settings',
  imports: [
    InterestTable,
    FormsModule,
    ProductionPriceTable,
    BindingDiscount,
    Simulator,
    SaveButton,
    InterestInput,
    SavingsInterests,
    DerivedTable
  ],
  templateUrl: './settings.html',
  // Use "table inputs" to align our inputs
  styleUrls: ['../../1-components/table-inputs.scss', './settings.scss']
})
export class Settings {
  public readonly service = inject(Configuration)
}
